import { Html } from "@react-three/drei";
import styles from "./Screen.module.css";
import React, { useRef } from "react";
import Module from "./Module";
import { useDispatch, useSelector } from "react-redux";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import modalContent from '../../UI/Modals/ModalContent.json'; // Importer le JSON

export default function Screen() {
  const sectionRef = useRef();
  const dispatch = useDispatch();
  const currentState = useSelector((state) => state.progression.currentState);

  useGSAP(() => {
    if (!sectionRef.current) return;
    if (currentState === "ServiceCenter") {
      gsap.to(sectionRef.current, {
        autoAlpha: 1,
        duration: 0.6,
        ease: "power2.out",
        onStart: () => gsap.set(sectionRef.current, { pointerEvents: "auto" }),
      });
    } else {
      gsap.to(sectionRef.current, {
        autoAlpha: 0,
        duration: 0.6,
        ease: "power2.out",
        onComplete: () => gsap.set(sectionRef.current, { pointerEvents: "none" }),
      });
    }
  }, [currentState]);

  return (
    <Html position={[0, 1.5, -4.5]} transform distanceFactor={2} zIndexRange={[10, 0]}>
      <section className={styles.screen} ref={sectionRef}>
        {Object.keys(modalContent.ServiceCenter).slice(0, 6).map((moduleKey) => (
          <Module
            key={moduleKey}
            module={moduleKey}
            src={modalContent.ServiceCenter[moduleKey].src}
            analytics={modalContent.ServiceCenter[moduleKey].analytics}
            dispatch={dispatch}
          />
        ))}
      </section>
    </Html>
  );
}
